import {overEvery} from '@yandex-delivery/utils'

import type {PickupPoint} from '../../../PickupRoute/types'
import {type Filter, filterFunctions} from './consts'
import type {FiltersValues} from './types'

export const isFilterValues = (filters: object, value?: Record<string, unknown>): value is FiltersValues => {
  if (value === undefined) {
    return true
  }

  const filterValues = Object.values(filters)

  return Object.keys(value).every(key => filterValues.includes(key))
}

export const getFilterFunction = (filters: FiltersValues) => {
  const keys = Object.keys(filters) as Array<Filter>

  return overEvery(
    keys
      .filter(key => Boolean(filters[key as Filter]))
      .map(key => {
        const filterValue = filters[key]
        const filterFunction = filterFunctions[key]
        return (station: PickupPoint) => filterFunction(station, filterValue)
      }),
  )
}
